import React from 'react'
import compose from '@shopify/react-compose'

import { withConfiguration } from '@portal/kit/pkg/components'

import LiveAgent from 'services/liveagent'

const ChatLoader = ({ portalConfiguration }) => {
  return <LiveAgent portalConfiguration={portalConfiguration} />
}

export default compose(
  withConfiguration
)(ChatLoader)
